// Question definitions for the SCS "Clinical Laboratory Evaluations" wizard.
//
// Mirrors scsAnalysisOfAdverseEventsQuestions — the two pages ask the same
// shaped questions (a table, the categories to report, then one or more
// comparison groupings), so they share attribute names wherever the answer is
// the same answer: `number` is the stable badge shown in the CSR-style index
// badge (page order, hardcoded — it does not renumber as conditional sections
// toggle), `text` is the fallback wording and `tooltip` holds the ticket
// INFORMATION/helper text (the endpoint returns wording only, no tooltip map).
//
// At runtime the wording is overridden by
// GET /clinical_summaries/safety_summary/questions, keyed by the same attribute
// the answer is stored under. `textKey` names the attribute to read that
// wording from when it differs from the local key — the comparison questions
// (Q4–Q6) are the Description of Studies questions repeated per grouping, so
// they reuse that page's wording and only their badge number changes.

export const SCS_CLE_QUESTIONS = {
  qLabTable: {
    number: 1,
    text: "What Clinical laboratory evaluation table do you want to report on?",
  },
  qLabEvalTypes: {
    number: 2,
    required: true,
    text: "Which evaluations do you want to report?",
  },
  qLabAdditionalGroupingName: {
    number: 3,
    text: "Which additional groupings do you want to compare? Name the grouping and then select the studies in this grouping.",
  },
  qLabComparisonType: {
    number: 4,
    // The endpoint has no wording for this question yet; it is the same
    // question as Q7 of the Description of Studies page.
    textKey: "qComparisonType",
    text: "How is the grouping compared?",
  },
  // Q5 / Q6 below are the Description of Studies branch questions (its Q8 / Q9)
  // shown for the comparison type picked in Q4.
  qNonComparativeGroupNames: {
    number: 5,
    text: "What are the actual names used to describe the treatment/analysis groups in the column headers?",
  },
  qTreatmentGroupNames: {
    number: 5,
    text: "What are the actual names used to describe the treatment/analysis groups in the column headers? Please define the role for each column name.",
  },
  qComparisonPairs: {
    number: 6,
    text: "Which dose/treatment groups should be compared?",
  },
  qDoseGroups: {
    number: 5,
    text: "Please list the dose group column headers from lowest to highest, starting with Placebo if present.",
  },
};

// The clinical laboratory evaluation categories offered by Q2. `label` is both
// the multi-select option and the wording saved as the answer; `key` is the
// category's stable identifier.
//
// TODO: the questions endpoint carries no wording for these yet, so the labels
// are hardcoded here — swap them for the served wording once it is available.
export const SCS_LAB_EVAL_TYPE_OPTIONS = [
  { key: "clinical_chemistry", label: "Clinical chemistry" },
  { key: "haematology", label: "Haematology" },
  { key: "urinalysis", label: "Urinalysis" },
  { key: "vital_signs", label: "Vital signs" },
  { key: "ecg", label: "ECG" },
];
